import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import axiosConn from "config/axiosConn";
import StateList from "../../helper/State_List.json";
import DistrictList from "../../helper/District_List.json";
import { useNavigate } from "react-router-dom";
import { FormGroup, Form, Input, Row, Col } from "reactstrap";
import { jwtDecode } from "jwt-decode";
import Helper from "../../helper/Common_Helper.js";
import { handleSpeak, handleSpeakWithoutVoice } from "./speechHandlers";
import { handleFocusChange, skipFocusChange } from "./formUtils";
import InputField from "./InputField";
import "react-toastify/dist/ReactToastify.css";
import { useSpeechRecognition } from "react-speech-recognition";
import { Formik, Field, ErrorMessage } from "formik";
import { useRef } from "react";
import Langfield from "../../assets/Json/accountFormLang.json";
import { FastForward } from "phosphor-react";
import * as Yup from "yup";
import InputField12 from "./InputField12";
import VirtualKeyboard from "./VirtualKeyboard/VirtualKeyboard";
import FacultySideBar from "./FacultySideBar";
import { MdCancel } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ExifReader from "exifreader";
import CustomDropdown from "./CustomDropdown"
import { changeLang, selectedVoice } from '../../redux/langSlice'
import { useDispatch } from 'react-redux'
import { FaBarsStaggered } from "react-icons/fa6";
import { useSelector } from "react-redux";
import SpinnerOverlay from "./Spinner";
import imageCompression from "browser-image-compression";
import { getCurrentCoords, embedGpsExif, getGeoFailureMessage } from "./gpsFallbackUtils";
function EventManagement() {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [selectedThemeData, setSelectedThemeData] = useState();
  const [udise_id, setUDISECode] = useState("");
  const [unit, setUnit] = useState();
  const [selectedEventId, setSelectedEventId] = useState("");
  const [data, setThemeList] = useState([]);
  const [slectedState, setState] = useState("");
  const [slectedDistrict, setDistrict] = useState("");
  const [role, setRole] = useState("");
  const [fileName, setFileName] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formattedDate, setFormattedDate] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const dispatch = useDispatch();

  const [videoFileName, setVideoFileName] = useState([]);
  // const [langSelected, setLangSelected] = useSelector(state => state.lang.lang);
  // const userData = useSelector(state => state.auth.user); 
 
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userData = useSelector(state => state.auth.user);
  console.log(userData,"userData")
  const [voiceSelected, setVoiceSelected] = useState(userData?.voice);
  const langSelected=userData.lang;
  const [initialValues, setInitialValues] = useState({
    udise_id: "",
    event_name: "",
    theme_name: "",
    sub_themes: [],
    implemnt_mode: "",
    event_type: "",
    number_events: "",
    event_date: "",
    isEventTechIntervention: "",
    haveParticipantPledge: "",
    number_participant_age3to8: "",
    number_participant_age8to11: "",
    number_participant_age11to14: "",
    number_participant_age14to18: "",
    number_participant_age18plus: "",
    state: "",
    district: "",
    city: "",
  });

  

  const disableRef = useRef(false);
  const nextValueRef = useRef(0);
  const resetRef = useRef(0);
  const translations = Langfield[langSelected];
  // Change option selected
  const label = document.querySelector(".dropdown__filter-selected");
  const options = Array.from(
    document.querySelectorAll(".dropdown__select-option")
  );

  options.forEach((option) => {
    option.addEventListener("click", () => {
      label.textContent = option.textContent;
    });
  });

  // Close dropdown onclick outside
  document.addEventListener("click", (e) => {
    const toggle = document.querySelector(".dropdown__switch");
    const element = e.target;

    if (element === toggle) return;

    const isDropdownChild = element.closest(".dropdown__filter");
  });
  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== "object" || translations === null) {
      return key; // Return the key if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== "string") {
      return key; // Return the value as is if key is not a string
    }

    return translations[key] || key.replace(/_/g, " "); // Use translation or fallback to the key
  };
  const nameRef = useRef(null);
  const lifeThemeRef = useRef(null);
  const subThemeRef = useRef(null);
  const modeRef = useRef(null);
  const eventTypeRef = useRef(null);
  const numberEventsRef = useRef(null);
  const eventDataRef = useRef(null);
  const techInterventionRef = useRef(null);
  const participantPledgeRef = useRef(null);
  const age3to8Ref = useRef(null);
  const age8to11Ref = useRef(null);
  const age11to14Ref = useRef(null);
  const age14to18Ref = useRef(null);
  const age18plusRef = useRef(null);
  const stateRef = useRef(null);
  const districtRef = useRef(null);
  const cityRef = useRef(null);
  const imageRef = useRef(null);
  const videoRef = useRef(null);
  const photoCaptionRef = useRef(null);
  const videoCaptionRef = useRef(null);
  const themeImpactRef = useRef(null);
  const onBtnRef = useRef(null);
  const saplingsPlantedRef = useRef(null);
  const visitsOrganisedRef = useRef(null);
  const kitchenGardensRef = useRef(null);
  const organicProduceRef = useRef(null);
  const eWasteCollectedRef = useRef(null);
  const compostPitsRef = useRef(null);
  const organicWasteRef = useRef(null);
  const organicCompostRef = useRef(null);
  const electricityUnitsRef = useRef(null);
  const renewablePowerRef = useRef(null);
  const leaksDetectedRef = useRef(null);
  const waterConsumptionRef = useRef(null);
  const singleUsePlasticFreeRef = useRef(null);
  const singleUsePlasticCollectedRef = useRef(null);
  const singleUsePlasticBottleCollectedRef = useRef(null);

  const isKeyBoardInput = useRef(false);
  const {
    browserSupportsSpeechRecognition,
    listening,
    transcript,
    resetTranscript,
  } = useSpeechRecognition();
  const getActiveState = useRef("event_name");
  const [getActive, setActive] = useState("");

  const nextRef = [
    nameRef,
    lifeThemeRef,
    subThemeRef,
    modeRef,
    eventTypeRef,
    numberEventsRef,
    eventDataRef,
    techInterventionRef,
    participantPledgeRef,
    age3to8Ref,
    age8to11Ref,
    age11to14Ref,
    age14to18Ref,
    age18plusRef,
    stateRef,
    districtRef,
    cityRef,
    imageRef,
    videoRef,
    photoCaptionRef,
    videoCaptionRef,
    themeImpactRef,
  ];
  let timer = null;

  useEffect(() => {
    localStorage.removeItem("selectedLanguage");
    localStorage.removeItem("show");
    localStorage.removeItem("hideTranslationButton");
    localStorage.removeItem("key");
    handleFocusChange(nextRef, nextValueRef, resetRef, timer);
  }, []);

  const handleActive = (e) => {
    const elementId = e.target.id;
    setActive(elementId);
  };

  useEffect(() => {
    // let token = localStorage.getItem("token");
    if (userData) {
      // let auth = jwtDecode(token);
      setInitialValues({
        ...initialValues,
        ["udise_id"]: userData.udise_id,
      });
      // getLanguageFunction({ udise_id: userData.udise_id });
      setRole(userData.role);
      setUDISECode(userData.udise_id);
      if (userData.role === 2) {
        getThemes({ udise_id: userData.udise_id });
      } else {
        getFacultyThemeList({ udise_id: userData.udise_id, email: userData.email });
      }
    }
  }, [userData]);

  // const getLanguageFunction = async (data) => {
  //   try {
  //     const response = await axiosConn("post", "get-language", data);
  //     if (response.data.status === "success") {
  //       let lang = response.data.result.lang;
  //       let voice = response.data.result.voice;
  //       // setLangSelected(lang);
  //       setVoiceSelected(voice);
  //       dispatch(changeLang(lang));
  //       dispatch(selectedVoice(voice));
  //       localStorage.setItem("langCode", lang);
  //       localStorage.setItem("voice", voice);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  //   setInitialValues({
  //     ...initialValues,
  //     district: "Select District",
  //   });
  //   setIsEmpty(false)
  //   setSelectedThemeData({
  //     ...selectedThemeData,
  //     district: "Select District",
  //   });

  //   if (userData) {
  //     console.log("userData", userData);  
  //     setInitialValues({
  //       ...initialValues,
  //       ["udise_id"]: userData?.udise_id,
  //       ["school_name"]: userData?.school_name,
  //       ["state"]: userData?.state,
  //       ["district"]: userData?.district,
  //     });
      
  //     setState(userData?.state);
      
  //     setDistrict(userData?.district);
  //     setRole(userData?.role);
  //     getLanguageFunction({ udise_id: userData?.udise_id });
  //   }

  // };

  const handleSelectState = (data) => {
    setInitialValues({
      ...initialValues,
      state: data,
      district: "Select District",
    });
    setIsEmpty(false)
    setSelectedThemeData({
      ...selectedThemeData,
      state: data,
      district: "Select District",
    });
    setDistrict("");
    let State = StateList.find((obj) => obj.state_id === data)?.state_name;
    setState(State);
      const filteredDistricts = DistrictList.filter(
        (district) => String(district.state_id) === String(data)
      );
      setFilterDistrict(filteredDistricts);
  };

  const location = useLocation();
  const Selecteddata = location.state || "";

  const getThemes = async (data) => {
    console.log("data---------------------------------22222222222222222222222222", data); 
    try {
      setSubmitting(true);
      let response = await axiosConn("post", "get-themes", data,{},dispatch);
      if (response.data.status === "success") {
        setThemeList(response.data.data.filter(item => (item.status === 1)));
        const themeOptions = response.data.data.filter(item => (item.status === 1));
        console.log(themeOptions,"themeOptions")
        console.log(langSelected,"themeOptions")
        setSubmitting(false);
        // console.log(response.data.data.filter(item => item.status === 1), "response.data.data");
      }
    } catch (error) {
      setSubmitting(false);
      console.log(error);
    }
  };
  useEffect(() => {
    if(data){
      setThemeList(data.filter(item => (item.status === 1)));
    }
  }, [langSelected]);

  useEffect(() => {
    if (Selecteddata) {
      setSelectedEventId(Selecteddata.item._id);
      setSelectedThemeData(Selecteddata.item);
      setFormattedDate(Selecteddata.item.event_date);
      setInitialValues(Selecteddata.item);
      setFileName(Selecteddata.item.photos);
      setVideoFileName(Selecteddata.item.videos);
      // setFormData(Selecteddata.item);
      handleSelectChangeTheme({ target: { value: Selecteddata.item._id } });
      if (Selecteddata.item.state) {
        // `state`/`district` are stored as names (not ids), so match on either
        // so the district options populate and the saved district resolves.
        const stateInfo = StateList.find(
          (obj) =>
            obj.state_id == Selecteddata.item.state ||
            obj.state_name === Selecteddata.item.state
        );
        if (stateInfo) {
          setState(stateInfo.state_name);
          const filteredDistricts = DistrictList.filter(
            (district) => district.state_id == stateInfo.state_id
          );
          setFilterDistrict(filteredDistricts);

          if (Selecteddata.item.district) {
            const districtInfo = filteredDistricts.find(
              (obj) =>
                obj.district_id == Selecteddata.item.district ||
                obj.district_name === Selecteddata.item.district
            );
            if (districtInfo) {
              setDistrict(districtInfo.district_name);
              // Store the id so the <select> (option values are district ids)
              // pre-selects the saved district.
              setInitialValues((prev) => ({
                ...prev,
                district: districtInfo.district_id,
              }));
            }
          }
        }
      }
      setShowForm(true);
    }
  }, [Selecteddata]);

  // Keep the district options in sync with the selected/loaded state so the
  // district dropdown can always pre-select the saved value (defends against
  // the load effect's state lookup racing with other state updates).
  useEffect(() => {
    const stateVal = slectedState || initialValues.state || selectedThemeData?.state;
    if (!stateVal) return;
    const stateInfo = StateList.find(
      (obj) => obj.state_id == stateVal || obj.state_name === stateVal
    );
    if (stateInfo) {
      setFilterDistrict(
        DistrictList.filter((obj) => obj.state_id == stateInfo.state_id)
      );
    }
  }, [slectedState, initialValues.state, selectedThemeData?.state]);

  const getFacultyThemeList = async (data) => {
    console.log("data---------------------------------", data);
    try {
      data["page"] = 1;
      data["limit"] = 20;
      const response = await axiosConn(
        "post",
        `get-faculty-assigned-event`,
        data
      );
      console.log("response======================================", response);
      if (response.data.status === "success") {
        setThemeList(response.data.data.filter(item => (item.status === 1)));
        // const themeOptions = response.data.data.filter(item => (item.status === 1));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInitialValues({
      ...initialValues,
      [name]: value,
    });
    setIsEmpty(false)
  };
  
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setInitialValues({
      ...initialValues,
      [name]: value,
    });
    setIsEmpty(false)
  };

  const handleSubThemeChange = (selectedOptions) => {
    setInitialValues({
      ...initialValues,
      sub_themes: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    });
    setIsEmpty(false)
  };

  const handleSelectChangeTheme = (value) => {
    setSelectedEventId(value);
  };
  console.log(initialValues,"initialValues")
  function convertToDecimal(degrees, minutes, seconds, fractionOfSeconds) {
    // Convert DMS (Degrees, Minutes, Seconds, Fraction of Seconds) to Decimal Degrees
    const totalSeconds = seconds + (fractionOfSeconds / 100);
    return degrees + (minutes / 60) + (totalSeconds / 3600);
  }
  
  // Robust EXIF GPS → signed decimal degrees: prefers ExifReader's decoded
  // `description`, falls back to the raw DMS rational array, and applies the
  // N/S · E/W sign. Returns NaN if unparseable so the caller can reject the photo.
  function extractGPS(tag, refTag) {
    if (!tag) return NaN;
    let dec = typeof tag.description === "number" ? tag.description : parseFloat(tag.description);
    if (!Number.isFinite(dec) && Array.isArray(tag.value)) {
      const toNum = (x) => (Array.isArray(x) ? (x[1] ? x[0] / x[1] : x[0]) : Number(x));
      const d = toNum(tag.value[0]);
      const m = tag.value.length > 1 ? toNum(tag.value[1]) : 0;
      const s = tag.value.length > 2 ? toNum(tag.value[2]) : 0;
      dec = d + m / 60 + s / 3600;
    }
    if (!Number.isFinite(dec)) return NaN;
    // Only the first character decides the hemisphere: ExifReader describes the
    // ref as e.g. "East longitude", and a substring check on "S"/"W" would match
    // the S in "EaSt" and negate every east longitude.
    const ref = String(refTag?.description ?? refTag?.value ?? "").trim().toUpperCase();
    if (ref.startsWith("S") || ref.startsWith("W")) dec = -Math.abs(dec);
    return dec;
  }
const [isEmpty, setIsEmpty] = useState(false);
  const handleSubmit = async (e) => {
    // console.log("initialValues", initialValues);
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const validations = [
        { condition: !/^\d{1,3}$/.test(initialValues.number_events), message: "Enter a valid number of events" },
        // { condition: !/^[a-zA-Z][a-zA-Z0-9]*$/.test(initialValues.cityName), message: "City name must start with a letter and contain only letters and numbers." },
        {
            condition: !initialValues.theme_name,
            message: "Please select a theme."

        },
        {
            condition: !initialValues.sub_themes.length,
            message: "Please select a sub-theme."
        },
        {
            condition: !initialValues.implemnt_mode,
            message: "Please select a mode of implementation."
        },
        {
            condition: !initialValues.event_type,
            message: "Please select an event type."
        },
        {
            condition: !initialValues.event_date,
            message: "Please select a date."
        },
        {
            condition: !initialValues.isEventTechIntervention,
            message: translate("Please select if the event includes a technological intervention.")
        },
        {
            condition: !initialValues.haveParticipantPledge,
            message: translate("Please select if all participants have taken the pledge.")
        },
        {
            condition:  !/^\d+$/.test(String(initialValues.number_participant_age3to8)),
            message: translate("Please enter a valid number of participants aged 3 to 8.")
        },
        {
            condition:  initialValues.number_participant_age3to8 >= 5000,
            message: translate("Number of participants aged 3 to 8 cannot be more than 5000.")
        },
        {
            condition: !/^\d+$/.test(String(initialValues.number_participant_age8to11)),
            message: translate("Please enter the number of participants aged 8 to 11.")
        },
        {
            condition:  initialValues.number_participant_age8to11 >= 5000,
            message: translate("Number of participants aged 8 to 11 cannot be more than 5000.")
        },
        {
            condition: !/^\d+$/.test(String(initialValues.number_participant_age11to14)),
            message: translate("Please enter the number of participants aged 11 to 14.")
        },
        {
            condition:  initialValues.number_participant_age11to14 >= 5000,
            message: translate("Number of participants aged 11 to 14 cannot be more than 5000.")
        },
        {
            condition: !/^\d+$/.test(String(initialValues.number_participant_age14to18)),
            message: translate("Please enter the number of participants aged 14 to 18.")
        },
        {
            condition:  initialValues.number_participant_age14to18 >= 5000,
            message: translate("Number of participants aged 14 to 18 cannot be more than 5000.")
        },
        {
            condition: !/^\d+$/.test(String(initialValues.number_participant_age18plus)),
            message: translate("Please enter the number of participants aged 18 and above.")
        },
        {
            condition: !initialValues.district || initialValues.district === "Select District" || initialValues.district === "",
            message: translate("Please select a district.")
        },
        {
            condition:  initialValues.number_participant_age18plus >= 5000,
            message: translate("Number of participants aged 18 and above cannot be more than 5000.")
        },
        {
            condition: (
                Number(initialValues.number_participant_age3to8) +
                Number(initialValues.number_participant_age8to11) +
                Number(initialValues.number_participant_age11to14) +
                Number(initialValues.number_participant_age14to18) +
                Number(initialValues.number_participant_age18plus)
            ) <= 0,
            message: translate("Please enter at least one participant.")
        },
        {
            condition: !initialValues.state,
            message: translate("Please select a state.")
        },
        {
            condition: !initialValues.city,
            message: translate("Please enter a city.")
        },
          {
    condition:
      initialValues.number_of_trees_Planted !== undefined &&
      Number(initialValues.number_of_trees_Planted) > 100,
    message: translate("Maximum allowed trees is 100."),
  },
  {
    condition:
      initialValues.number_of_trees_Planted_Miyawaki !== undefined &&
      Number(initialValues.number_of_trees_Planted_Miyawaki) > 20000,
    message: translate("Maximum allowed trees is 20000."),
  },
  {
    condition: !initialValues.number_of_trees_Planted && initialValues.sub_themes[0] === "Plantation Drive",
    message: translate("Please enter number of trees planted."),
  },
  {
    condition: !initialValues.number_of_trees_Planted_Miyawaki && initialValues.sub_themes[0] === "Miyawaki Forest",
    message: translate("Please enter number of trees planted."),
  },
  {
    condition:
      initialValues.Amount_of_ewaste_collected !== undefined &&
      initialValues.Amount_of_ewaste_collected !== "" &&
      Number(initialValues.Amount_of_ewaste_collected) > 100,
    message: translate("Amount of E-Waste collected cannot exceed 100 Kg."),
  },

    ];

        for (const { condition, message } of validations) {
          toast.dismiss();
            if (condition) { 
                toast.warning(message);
                setIsSubmitting(false);
                setIsEmpty(true);
                return;
            }
        }
        const postData = { ...initialValues };
        if (slectedState) {
            postData["state"] = slectedState;
        }
        if (slectedDistrict) {
            postData["district"] = slectedDistrict;
        }
        const matrixFields = [
            "electricity_units_consumed",
            "Units_of_renewable_power_generated",
            "saplings_planted",
            "visits_organised",
            "kitchen_gardens_created",
            "Amount_of_organic_produce",
            "Amount_of_ewaste_collected",
            "compost_pits_constructed",
            "organic_waste_generated",
            "organic_waste_generated_obtained",
            "leaks_detected",
            "Reduction_in_water",
            "Single_Use_Plastic_Free",
            "single_use_plastic_collected",
            "number_of_trees_labelled_qr",
            "number_of_trees_Planted_Miyawaki",
            "number_of_trees_Planted"
        ];

        const matrix = {};
        matrixFields.forEach((field) => {
            if (initialValues[field]) {
                matrix[field] = initialValues[field];
            }
        });

        postData["photos"] = fileName;
        postData["videos"] = videoFileName;
        postData["matrix"] = matrix;
        setSubmitting(true);

        console.log('465555555555555',postData);

        const response = await axiosConn("post", "update-theme", postData, {
          "Content-Type": "application/json",
        }, dispatch);

        if (response.data.status === "success") {
            toast.success("Event Updated Successfully!");
            setSubmitting(false);
            navigate("/faculty/eventlist");
        } else {
            toast.error(response.data.message || translate("Failed to update event"));
        }
    } catch (error) {
      setSubmitting(false);
        console.error("Update Error Details:", {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
        const errorMsg = error.response?.data?.message || translate("An error occurred during update. Please try again.");
        toast.error(errorMsg);
    } finally {
      setSubmitting(false);
        setIsSubmitting(false);
    }
};

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }

  const MAX_MB = 10;
    
      const handleFile = async (e) => {
  try {
    console.log("File input event triggered");

    const files = e.target.files;
    const allowedExtensions = ["png", "jpeg", "jpg"];
    const MAX_UPLOAD_COUNT = 5;

    console.log("Files received:", files);

    if (!files || files.length === 0) {
      toast.warning(translate("Please select at least one image"));
      return;
    }

    if (files.length > MAX_UPLOAD_COUNT) {
      toast.warning(translate(`You can only upload up to ${MAX_UPLOAD_COUNT} images at a time`));
      e.target.value = "";
      return;
    }

    setIsEmpty(false);
    const formData = new FormData();
    const photoPayload = [];

    // Device location is fetched at most once per upload batch and reused
    // for every non-geo-tagged photo in it.
    let deviceCoords = null;
    const getFallbackCoords = async () => {
      if (!deviceCoords) deviceCoords = await getCurrentCoords();
      return deviceCoords;
    };

    for (const file of files) {
      console.log("Processing file:", file.name);

      // 1. Validate file extension
      const ext = file.type.split("/")[1];
      if (!allowedExtensions.includes(ext)) {
        toast.warning(translate("Only PNG, JPEG and JPG files are allowed"));
        e.target.value = "";
        return;
      }

      // 2. Read EXIF GPS data; if missing, stamp the school's current location
      let tags = {};
      try {
        tags = await ExifReader.load(await file.arrayBuffer());
      } catch (exifErr) {
        console.warn("Failed to read EXIF:", exifErr);
      }

      let workingFile = file;
      let latitude = extractGPS(tags.GPSLatitude, tags.GPSLatitudeRef);
      let longitude = extractGPS(tags.GPSLongitude, tags.GPSLongitudeRef);

      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        // No usable GPS EXIF (camera without location, screenshot, WhatsApp
        // copy). Instead of rejecting, geo-tag the photo with the device's
        // current location — the faculty is uploading from the school.
        let coords;
        try {
          coords = await getFallbackCoords();
        } catch (geoErr) {
          console.warn("Geolocation unavailable:", geoErr);
          toast.warning(translate(await getGeoFailureMessage(geoErr)));
          e.target.value = "";
          return;
        }
        latitude = coords.latitude;
        longitude = coords.longitude;
        try {
          workingFile = await embedGpsExif(file, latitude, longitude);
        } catch (embedErr) {
          // EXIF write failed — still upload with the captured coordinates,
          // which is what the rest of the flow stores and displays.
          console.warn("Could not write GPS EXIF into the image:", embedErr);
        }
        toast.info(translate("This photo was not geo-tagged, so your current location has been added to it."));
      }

      // 3. Compress image if needed
      let processedFile = workingFile;
          const now = new Date();
  const section = "sectionA";

  // Format: YYYYMMDD_HHmmss
  const dateStr = now.toISOString().replace(/[:.]/g, "-");

  // workingFile may be a PNG re-encoded as JPEG, so take the extension
  // from it rather than the original file.
  const outExt = workingFile.type.split("/")[1];
  const newFileName = `${file.name}_${dateStr}_${section}.${outExt}`;

          if (workingFile.size > MAX_MB * 1024 * 1024) {
            const compressedBlob = await imageCompression(workingFile, {
              maxSizeMB       : MAX_MB,
              maxWidthOrHeight: 1920,   // prevent super-large dimensions
              useWebWorker    : true,
              // fileType        : "image/jpg", // best size / quality trade-off
            });
            processedFile = new File([compressedBlob], newFileName, { type: workingFile.type });
            // NB: EXIF is gone now, but we already have lat/long
          } else {
            processedFile = new File([workingFile], newFileName, { type: workingFile.type });
          }

      // 4. Append file to FormData
      formData.append("files", processedFile);
      photoPayload.push({ latitude, longitude });

      // 5. Local preview (optional for UI)
      const previewUrl = URL.createObjectURL(processedFile);
      console.log("Preview created for:", previewUrl);
    }

    // Append GPS data as JSON array string
    formData.append("gpsData", JSON.stringify(photoPayload));

    // 6. Upload files
    console.log("Uploading files...");
    const response = await fetch("https://ecoclubs.education.gov.in/api/upload-image-file", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    const data = await response.json();
    console.log("Upload response:", data);

    if (data.status === "success") {
      const uploadedUrls = data.data;

      // Match each photo with its respective GPS data
      const uploadedPhotos = uploadedUrls.map((url, i) => ({
        photo_url: url,
        latitude: photoPayload[i]?.latitude,
        longitude: photoPayload[i]?.longitude,
      }));

      setFileName((prev) => [...prev, ...uploadedPhotos]);
      toast.success(translate("Images uploaded successfully"));
    } else {
      toast.warning(translate("Failed to upload files"));
    }

    // Reset input
    e.target.value = "";
  } catch (err) {
    console.error("Image upload error:", err);
    toast.error(translate("Unexpected error while uploading images"));
    e.target.value = "";
  }
};

  const handleVideoFile = async (e) => {
    try {
      let allowedExtensions = ["mp4", "avi", "mkv"];
      let files = e.target.files;

      if (files.length >= 3) {
        toast.warning("You can only upload up to 3 files at a time");
        return;
      }
      setIsEmpty(false)
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        const fileExtension = files[i].type.split("/")[1];
        if (allowedExtensions.includes(fileExtension)) {
          if (files[i].size <= 8 * 1024 * 1024) {
            // Check file size (5 MB limit)
            formData.append("files", files[i]);
          } else {
            toast.warning("Each file must be less than 5 MB");
            e.target.value = "";
            return;
          }
        } else {
          toast.warning("Only video files (MP4, AVI, MKV) are allowed");
          e.target.value = "";
          return;
        }
      }

      const response = await axiosConn("post", "upload-video-file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        let uploadedFiles = response.data.data;
        setVideoFileName((prevFileName) => [...prevFileName, ...uploadedFiles]);
      } else {
        toast.warning("Failed to upload files");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const HandleSubmitEvent = (e) => {
    e.preventDefault();
    if (selectedEventId) {
      const selectedEvent = data.find((event) => event._id === selectedEventId);
      if (!selectedEvent) return; // Guard clause for invalid event
      // Consolidate values from selectedEvent
      const matrix = selectedEvent.matrix || {};
      const updatedValues = selectedEvent;

      Object.keys(matrix).forEach((key) => {
        if (
          matrix[key] !== undefined &&
          matrix[key] !== null &&
          matrix[key] !== ""
        ) {
          updatedValues[key] = matrix[key];
        }
      });
      // Update state with consolidated values
      setInitialValues(updatedValues);
      setFileName(selectedEvent.photos);
      setVideoFileName(selectedEvent.videos);
      setSelectedThemeData(selectedEvent);
      // setFormData(selectedEvent);
      // Format and set event date
      if (selectedEvent.event_date) {
        const date = new Date(selectedEvent.event_date);
        const formatted = date.toLocaleString();
        setFormattedDate(formatted);
      }

      // Determine and set unit based on theme name
      const themeUnits = {
        "LiFEStyles Adopted": "Total no of points earned",
        "Sustainable Food Systems Adopted": "Total no of points earned",
        "Waste Reduced (Swachhata Actions)": "Total waste reduction (in Kg)",
        "Reduced E-Waste": "Total Electronics waste reduction (in Kg)",
        "Energy Saved": "Total Energy conserved (in Watts)",
        "Water Saved": "Total water conserved (in Ltrs)",
      };

      setUnit(
        themeUnits[selectedEvent.theme_name] ||
        "Total reduction in plastic usage (in Kg)"
      );
      setShowForm(true);
    }
  };

  const InputFields = [
    {
      name: "event_name",
      label: translate("Name_of_Event"),
      type: "text",
      required: true,
      placeholder: translate("Name_of_Event"),
      innerRef: nameRef,
      disabled: true,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Name_of_Event")
        ),
    },
    {
      name: "theme_name",
      label: translate("Mission LiFE Theme *"),
      type: "select",
      required: true,
      disabled: true,
      selectOptions: [
        { label: translate("Select life theme"), value: "" },
        { label: translate("Energy_Saved"), value: "Energy Saved" },
        { label: translate("Water_Saved"), value: "Water Saved" },
        {
          label: translate("Single_Use_Plastic_Reduced"),
          value: "Single-Use Plastic Reduced",
        },
        {
          label: translate("Sustainable_Food_Systems_Adopted"),
          value: "Sustainable Food Systems Adopted",
        },
        {
          label: translate("Waste_Reduced(Swachhatta_Actions)"),
          value: "Waste Reduced (Swachhata Actions)",
        },
        { label: translate("LiFStyles_Adopted"), value: "LiFEStyles Adopted" },
        { label: translate("Reduced_E-waste"), value: "Reduced E-Waste" },
      ],
      innerRef: lifeThemeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Mission LiFE Theme ")
        ),
    },
    {
      name: "sub_themes",
      label: translate("Mission LiFE Sub-Themes *"),
      disabled: true,
      type: "select",
      selectOptions: [],
      innerRef: subThemeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Mission LiFE Sub-Themes ")
        ),
    },
    {
      name: "implemnt_mode",
      label: translate("Mode_of_Implementation"),
      type: "select",
      selectOptions: [
        { label: translate("Select_Mode"), value: "" },
        { label: translate("Digital"), value: translate("Digital") },
        { label: translate("Physical"), value: translate("Physical") },
      ],
      innerRef: modeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Mode_of_Implementation")
        ),
    },
    {
      name: "event_type",
      label: translate("Type_of_event"),
      type: "select",
      selectOptions: [
        { label: translate("Select_Event_Type"), value: "" },
        { label: translate("Action"), value: translate("Action") },
        { label: translate("Awareness"), value: translate("Awareness") },
        {
          label: translate("Action_&_Awareness_both"),
          value: translate("Action_&_Awareness_both"),
        },
      ],
      innerRef: eventTypeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Type_of_event")
        ),
    },
    {
      name: "number_events",
      label: translate("Number_of_Events"),
      type: "number",
      required: true,
      max: 5000,
      innerRef: numberEventsRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Number_of_Events")
        ),
    },
    {
      name: "event_date",
      label: translate("Date_and_Time"),
      type: "date",
      required: true,
      innerRef: eventDataRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Date_and_Time")
        ),
    },
    {
      name: "isEventTechIntervention",
      label: translate("Does_this_Event_include_a_technological_intervention"),
      type: "select",
      selectOptions: [
        {
          label: translate("Select"),
          value: "",
        },
        { label: translate("Yes"), value: translate("Yes") },
        { label: translate("No"), value: translate("No") },
      ],
      innerRef: techInterventionRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Does_this_Event_include_a_technological_intervention")
        ),
    },
    {
      name: "haveParticipantPledge",
      label: translate(
        "Have_All_Participants_Attending_Event_Taken_The_Pledge"
      ),
      type: "select",
      required: true,
      selectOptions: [
        {
          label: translate("Select"),
          value: "",
        },
        { label: translate("Yes"), value: translate("Yes") },
        { label: translate("No"), value: translate("No") },
      ],
      innerRef: participantPledgeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Have_All_Participants_Attending_Event_Taken_The_Pledge")
        ),
    },
    {
      name: "number_participant_age3to8",
      label: translate("Age_3_to_8"),
      type: "number",
      required: true,
      max: 5000,
      innerRef: age3to8Ref,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Age_3_to_8")
        ),
    },
    {
      name: "number_participant_age8to11",
      label: translate("Age_8_to_11"),
      type: "number",
      required: true,
      max: 5000,
      innerRef: age8to11Ref,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Age_8_to_11")
        ),
    },
    {
      name: "number_participant_age11to14",
      label: translate("Age_11_to_14"),
      type: "number",
      required: true,
      max: 5000,
      innerRef: age11to14Ref,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Age_11_to_14")
        ),
    },
    {
      name: "number_participant_age14to18",
      label: translate("Age_14_to_18"),
      type: "number",
      required: true,
      max: 5000,
      innerRef: age14to18Ref,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Age_14_to_18")
        ),
    },
    {
      name: "number_participant_age18plus",
      label: translate("Age_18_plus"),
      type: "number",
      required: true,
      max: 5000,
      innerRef: age18plusRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Age_18_plus")
        ),
    },
    {
      name: "state",
      label: translate("State"),
      type: "select",
      required: true,
      value: initialValues.state || (selectedThemeData && selectedThemeData.state) || "",
      selectOptions: [
        { label: translate("Select State"), value: "" },
        ...StateList.map((obj) => ({
          label: obj.state_name,
          value: obj.state_id,
        })),
      ],
      innerRef: stateRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("State")
        ),
    },
    {
      name: "district",
      label: translate("District"),
      type: "select",
      required: true,
      value: initialValues.district || (selectedThemeData && selectedThemeData.district) || "",
      selectOptions: [
        { label: translate("Select District"), value: "" }, // Placeholder with empty value
        ...filterDistrict.map((obj) => ({
          label: obj.district_name,
          value: obj.district_id,
        })),
      ],
      innerRef: districtRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("District")
        ),
    },
    {
      name: "city",
      label: translate("City"),
      type: "text",
      required: true,
      innerRef: cityRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("City")
        ),
    },

    {
      name: "photos",
      label: translate("Geotagged photos(Max 5 images, 10MB each)"),
      type: "file",
      placeholder: "",
      innerRef: imageRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          translate("Geotagged photos(Max 3 images, 10MB each)")
        ),
    },
    {
      name: "videos",
      label: translate("Upload Videos(Max 3 Videos, 5MB each)"),
      type: "file",
      placeholder: "",
      innerRef: videoRef,
      handleSpeak: (label) => handleSpeak(label, translate("Upload Videos")),
    },
  ];

  const captions = [
    {
      name: "photo_caption",
      label: translate("Photo Caption"),
      type: "text",
      placeholder: "",
      innerRef: photoCaptionRef,
      handleSpeak: (label) => handleSpeak(label, translate("Photo Caption")),
    },
    {
      name: "video_caption",
      label: translate("Video Caption"),
      type: "text",
      placeholder: "",
      innerRef: videoCaptionRef,
      handleSpeak: (label) => handleSpeak(label, translate("Video Caption")),
    },
  ];

  const handleMediaClick = (url, type) => {
    setMediaUrl(url);
    setIsVideo(type === "video");
    setModalShow(true);
  };

  const adoptHealthyLifestyles = [
    // {
    //   name: "saplings_planted",
    //   label: translate("Number of saplings planted"),
    //   type: "number",
    //   innerRef: saplingsPlantedRef,
    //   handleSpeak: (label) => {
    //     handleSpeak(
    //       label,
    //       langSelected,
    //       voiceSelected,
    //       getActiveState,
    //       onBtnRef,
    //       translate("Number of saplings planted"),
    //     );
    //   },
    // },
    // {
    //   name: "visits_organised",
    //   label: translate("Number of Nature walks conducted"),
    //   type: "number",
    //   innerRef: visitsOrganisedRef,
    //   handleSpeak: (label) => {
    //     handleSpeak(
    //       label,
    //       langSelected,
    //       voiceSelected,
    //       getActiveState,
    //       onBtnRef,
    //       translate("Number of Nature walks conducted")
    //     );
    //   },
    // },
    //  {
    //     name: "number_of_trees_labelled_qr",
    //       label: translate("Number of trees labelled with QR code"),
    //       type: "number",
    //       innerRef: saplingsPlantedRef,
    //       handleSpeak: (label) => {
    //         handleSpeak(
    //           label,
    //           langSelected,
    //           voiceSelected,
    //           getActiveState,
    //           onBtnRef,
    //           translate("Number of of trees labelled with QR code"),
    //         );
    //       },
    //     },
      ...(selectedThemeData?.sub_themes?.[0] === "Miyawaki Forest"
        ? [
            {
              name: "number_of_trees_Planted_Miyawaki",
              label: translate("No. of Trees Planted"),
              type: "number",
              max: 5000,
              innerRef: saplingsPlantedRef,
              handleSpeak: (label) => {
                handleSpeak(label, langSelected, voiceSelected, getActiveState, onBtnRef, translate("Number of trees planted"));
              },
            },
          ]
        : [
            {
              name: "number_of_trees_Planted",
              label: translate("No. of Trees Planted"),
              type: "number",
              max: 5000,
              innerRef: saplingsPlantedRef,
              handleSpeak: (label) => {
                handleSpeak(label, langSelected, voiceSelected, getActiveState, onBtnRef, translate("Number of trees planted"));
              },
            },
          ]
      ),
  ];

  const adoptSustainableFoodSystems = [
    {
      name: "kitchen_gardens_created",
      label: translate("Whether School Nutrition Garden established"),
      type: "select",
      selectOptions: [
        {
          label: translate("Select"),
          value: "",
        },
        { label: translate("Yes"), value:"Yes" },
        { label: translate("No"), value:"No" },
      ],
      innerRef: kitchenGardensRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Whether School Nutrition Garden established")
        ),
    },
    {
      name: "Amount_of_organic_produce",
      label: translate("Amount of Harvest produced"),
      type: "number",
      max: 5000,
      innerRef: organicProduceRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Amount of Harvest produced")
        );
      },
    },
  ];



  const reduceEwaste = [
    {
      name: "Amount_of_ewaste_collected",
      label: translate(
        "Amount of e-waste collected (Kg)"
      ),
      type: "number",
      max: 100,
      innerRef: eWasteCollectedRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate(
            "Amount of e-waste collected (Kg)"
          )
        );
      },
    },
  ];

  const reduceWaste = [
    {
      name: "compost_pits_constructed",
      label: translate("Number of compost pits constructed"),
      type: "number",
      max: 5000,
      innerRef: compostPitsRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Number of compost pits constructed")
        );
      },
    },
    {
      name: "organic_waste_generated",
      label: translate("Amount of organic waste generated"),
      type: "number",
      max: 5000,
      innerRef: organicWasteRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Amount of organic waste generated")
        );
      },
    },
    {
      name: "organic_compost_obtained",
      label: translate("Amount of organic compost obtained"),
      type: "number",
      innerRef: organicCompostRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Amount of organic compost obtained")
        );
      },
    },
  ];

  const saveEnergy = [
    // {
    //   name: "electricity_units_consumed",
    //   label: translate("Number of electricity units consumed"),
    //   type: "number",
    //   innerRef: electricityUnitsRef,
    //   handleSpeak: (label) => {
    //     handleSpeak(
    //       label,
    //       langSelected,
    //       voiceSelected,
    //       getActiveState,
    //       onBtnRef,
    //       translate("Number of electricity units consumed")
    //     );
    //   },
    // },
    {
      name: "electricity_units_consumed",
      label: translate("Whether solar panels established in school"),
      type: "select",
      required: true,
      selectOptions: [
        {
          label: translate("Select"),
          value: "",
        },
        { label: translate("Yes"), value: translate("Yes") },
        { label: translate("No"), value: translate("No") },
      ],
      innerRef: electricityUnitsRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Whether solar panels established in school")
        );
      },
    },
    // {
    //   name: "Units_of_renewable_power_generated",
    //   label: translate(
    //     "Units of renewable power generated (incase solar panel/hydro/wind installed in school)"
    //   ),
    //   type: "number",
    //   innerRef: renewablePowerRef,
    //   handleSpeak: (label) => {
    //     handleSpeak(
    //       label,
    //       langSelected,
    //       voiceSelected,
    //       getActiveState,
    //       onBtnRef,
    //       translate(
    //         "Units of renewable power generated (incase solar panel/hydro/wind installed in school)"
    //       )
    //     );
    //   },
    // },
  ];

  const saveWater = [
    {
      name: "leaks_detected",
      label: translate("Number of leaks detected"),
      type: "number",
      max: 5000,
      innerRef: leaksDetectedRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Number of leaks detected")
        );
      },
    },
    {
      name: "Reduction_in_water",
      label: translate("Reduction in water conservation over a period of month"),
      type: "number",
      max: 5000,
      innerRef: waterConsumptionRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Reduction in water conservation over a period of month")
        );
      },
    },
  ];

  const sayNoToSingleUsePlastic = [
    // {
    //   name: "Single_Use_Plastic_Free",
    //   label: translate("Whether school declared Single Use Plastic Free"),
    //   type: "select",
    //   selectOptions: [
    //     {
    //       label: "Select",
    //       value: "",
    //     },
    //     {
    //       label: "Yes",
    //       value: "Yes",
    //     },
    //     {
    //       label: "No",
    //       value: "No",
    //     },
    //   ],
    //   innerRef: singleUsePlasticFreeRef,
    //   handleSpeak: (label) => {
    //     handleSpeak(
    //       label,
    //       langSelected,
    //       voiceSelected,
    //       getActiveState,
    //       onBtnRef,
    //       translate("Whether school declared Single Use Plastic Free")
    //     );
    //   },
    // },
    // {
    //   name: "single_use_plastic_collected",
    //   label: translate("Amount of single use plastic collected"),
    //   type: "number",
    //   innerRef: singleUsePlasticCollectedRef,
    //   handleSpeak: (label) => {
    //     handleSpeak(
    //       label,
    //       langSelected,
    //       voiceSelected,
    //       getActiveState,
    //       onBtnRef,
    //       translate("Amount of single use plastic collected")
    //     );
    //   },
    // },

    {
      name: "single_use_plastic_collected",
      label: translate("Amount of plastic waste collected"),
      type: "number",
      max: 5000,
      innerRef: singleUsePlasticCollectedRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Amount of plastic waste collected")
        );
      },
    },
    {
      name: "single_use_plastic_bottle_collected",
      label: translate("Number of Plastic water bottles replaced"),
      type: "number",
      max: 5000,
      innerRef: singleUsePlasticBottleCollectedRef,
      handleSpeak: (label) => {
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Number of Plastic water bottles replaced")
        );
      },
    },
  ];

  const formatDateForInput = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const renderInputFields = (fieldConfig, setFieldValue, size = 4) => {
    return fieldConfig.type === "select" ? (
      <div
        key={fieldConfig.name}
        onFocus={(e) => {
          handleActive(e);
        }}
        className={`col-4 form-group ${getActive === fieldConfig.name ? "active" : null
          } `}
      >
        <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>
        <div className="formgroupIn">
          <Field
            onFocus={(e) => {
              getActiveState.current = fieldConfig.name;
              handleActive(e);
              handleSpeakWithoutVoice(
                fieldConfig.name,
                langSelected,
                voiceSelected,
                getActiveState,
                fieldConfig.label
              );
            }}
            innerRef={fieldConfig.innerRef}
            as="select"
            className="form-control"
            id={fieldConfig.name}
            name={fieldConfig.name}
            disabled={
              (disableRef.current === true
                ? getActive === fieldConfig.name
                  ? false
                  : false
                : false) || fieldConfig.disabled
            }
            onChange={(e) => {
              const value = e.target.value;
              setInitialValues({
                ...initialValues,
                [fieldConfig.name]: value,
              });
              setFieldValue(fieldConfig.name, value);
              handleFocusChange(nextRef, nextValueRef, resetRef, timer);
              setIsEmpty(false);
            }}
          >
            {selectedThemeData[fieldConfig.name] &&
            <option key={fieldConfig.value} value={fieldConfig.value}>
              {selectedThemeData[fieldConfig.name]}
            </option>}

            {fieldConfig.selectOptions.map((option) => {
  // Check if fieldConfig has a value and don't display the "Select" option
  const selectedValue = selectedThemeData[fieldConfig.name];
  
  // Only show the option if the selectedValue is not equal to option.value
  // and we are not currently on the "Select" option
  if (selectedValue!=="" && option.value === "") {
    return null; // Skip rendering "Select" option if there's already a selected value
  }

  if (selectedValue && selectedValue === option.value) {
    return null; // Skip rendering the already selected option
  }

  return (
    <option key={option.value} value={option.value}>
      {translate(option.label)}
    </option>
  );
})}

          </Field>
        </div>
      </div>
    ) : fieldConfig.type === "file" ? (
      <div
        onFocus={(e) => handleActive(e)}
        className={` col-4  form-group ${getActive === fieldConfig.name ? "active" : null
          }`}
      >
        <label htmlFor="">{translate(fieldConfig.label)}</label>

        <div className="formgroupIn">
          <Field
            onFocus={(e) => handleSpeak(translate(fieldConfig.name))}
            name="file"
            type="file"
            // accept={fieldConfig.name === "photos" ? "image/*" : "video/*"}
            multiple
            onChange={(e) => {
              if (fieldConfig.name === "photos") {
                handleFile(e);
              } else {
                handleVideoFile(e);
              }
            }}
            ref={fieldConfig.innerRef}
            id={fieldConfig.name}
            className="form-control"
            disabled={
              (disableRef.current === true
                ? getActive === fieldConfig.name
                  ? false
                  : true
                : false) ||
              fieldConfig.disabled ||
              (fieldConfig.name === "photos" && fileName.length >= 5) ||
              (fieldConfig.name === "videos" && videoFileName.length >= 3)
            }
          />
        </div>

        <ErrorMessage name="file" component="div" />
        <ul>
          {fieldConfig.name === "photos" &&
            fileName.map((file, index) => (
              <li key={index}>
                <Link
                  onClick={() =>
                    handleMediaClick(
                      file?.photo_url,
                      "image"
                    )
                  }
                >
                  {" "}
                  image- {index + 1}
                </Link>
                {fileName && index < 1 ? (
                  ""
                ) : (
                  <MdCancel
                    color="red"
                    onClick={(e) => {
                      const newFile = fileName.filter((item, i) => i !== index);
                      setFileName(newFile);
                    }}
                  />
                )}
              </li>
            ))}
          {fieldConfig.name === "videos" &&
            videoFileName.map((file, index) => (
              <li key={index}>
                <Link
                  onClick={() =>
                    handleMediaClick(
                       `${file.split('?sp')[0]}?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D`,
                      "video"
                    )
                  }
                >
                  Video- {index + 1}
                </Link>
                {fileName && index < 1 ? (
                  ""
                ) : (
                  <MdCancel
                    color="red"
                    onClick={(e) => {
                      const newFile = videoFileName.filter(
                        (item, i) => i !== index
                      );
                      setVideoFileName(newFile);
                    }}
                  />
                )}
              </li>
            ))}
        </ul>
      </div>
    ) : fieldConfig.type === "date" ? (
      <div
        ref={fieldConfig.innerRef}
        onFocus={(e) => {
          getActiveState.current = fieldConfig.name;
          handleActive(e);
          handleSpeakWithoutVoice(
            fieldConfig.name,
            langSelected,
            voiceSelected,
            getActiveState,
            fieldConfig.label
          );
        }}
        className={` col-4  form-group ${getActive === fieldConfig.name ? "active" : null
          }`}
      >
        {getActive === fieldConfig.name && (
          <div
            className="skipBtn"
            style={{ cursor: "pointer" }}
            onClick={() => {
              skipFocusChange(
                nextRef,
                nextValueRef,
                handleFocusChange,
                resetRef,
                timer
              );
            }}
          >
            {translate("Skip")} <FastForward size={18} />
          </div>
        )}
        <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>

        <div className="formgroupIn">
          <Input
            name="event_date"
            min={Helper.currentOrFutureDate()}
            placeholder=""
            type="datetime-local"
            value={formatDateForInput(initialValues.event_date) || ""}
            onChange={handleInputChange}
          />
          <span className="inptIcn"></span>
        </div>
      </div>
    ) : fieldConfig.type === "text" ? (
      <InputField
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        // saveField={saveField}
        size={size}
        key={fieldConfig.name}
        name={fieldConfig.name}
        value={initialValues[fieldConfig.name]}
        disabled={fieldConfig.disabled}
        label={fieldConfig.label}
        placeholder={fieldConfig.placeholder}
        innerRef={fieldConfig.innerRef}
        handleSpeak={fieldConfig.handleSpeak}
        handleFocusChange={handleFocusChange}
        nextRef={nextRef}
        nextValueRef={nextValueRef}
        resetRef={resetRef}
        timer={timer}
        setFieldValue={setFieldValue}
        getActive={getActive}
        handleActive={handleActive}
        langSelected={langSelected}
        getActiveState={getActiveState}
        onBtnRef={onBtnRef}
        skipFocusChange={skipFocusChange}
        skipBtn={translate("Skip")}
        transcript={transcript}
        listening={listening}
        voiceSelected={voiceSelected}
        resetTranscript={resetTranscript}
        required={fieldConfig.required}
        isKeyBoardInput={isKeyBoardInput}
        handleSpeakWithoutVoice={handleSpeakWithoutVoice}
        disableRef={disableRef}
        requiredBtn={translate("Required")}
      />
    ) : fieldConfig.disabled ? (
      <div
        onFocus={(e) => handleActive(e)}
        className={` col-6  form-group ${getActive === fieldConfig.name ? "active" : null
          }`}
      >
        <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>
        <div className="formgroupIn">
          <Field
            onFocus={(e) => {
              getActiveState.current = fieldConfig.name;
              handleActive(e);
              handleSpeakWithoutVoice(
                fieldConfig.name,
                langSelected,
                voiceSelected,
                getActiveState,
                fieldConfig.label
              );
            }}
            innerRef={fieldConfig.innerRef}
            type={fieldConfig.type}
            className="form-control"
            id={fieldConfig.name}
            name={fieldConfig.name}
            placeholder={fieldConfig.placeholder}
            disabled={fieldConfig.disabled}
          />
          <span className="inptIcn"></span>
        </div>
      </div>
    ) : (
      <InputField
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        size={size}
        // saveField={saveField}
        key={fieldConfig.name}
        name={fieldConfig.name}
        type={fieldConfig.type}
        value={initialValues[fieldConfig.name]}
        disabled={fieldConfig.disabled}
        label={fieldConfig.label}
        placeholder={fieldConfig.placeholder}
        innerRef={fieldConfig.innerRef}
        handleSpeak={fieldConfig.handleSpeak}
        handleFocusChange={handleFocusChange}
        nextRef={nextRef}
        nextValueRef={nextValueRef}
        resetRef={resetRef}
        timer={timer}
        setFieldValue={setFieldValue}
        getActive={getActive}
        handleActive={handleActive}
        langSelected={langSelected}
        getActiveState={getActiveState}
        onBtnRef={onBtnRef}
        skipFocusChange={skipFocusChange}
        skipBtn={translate("Skip")}
        transcript={transcript}
        listening={listening}
        voiceSelected={voiceSelected}
        resetTranscript={resetTranscript}
        max={fieldConfig.max}
        required={fieldConfig.required}
        isKeyBoardInput={isKeyBoardInput}
        handleSpeakWithoutVoice={handleSpeakWithoutVoice}
        disableRef={disableRef}
        requiredBtn={translate("Required")}
      />
    );
  };

  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  }
  return (
    <>
    {submitting && <SpinnerOverlay />}

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={Yup.object().shape({})}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
        }}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form className="bg-blue-900">
            <section className="scholdashbrdSec">
              <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
                <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
              </div>
              <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
              <FacultySideBar langSelected={langSelected} index={2} role={role} />
              </div>
              <div className="schlDashbrdRgt">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card-user pageContainer">
                      <div class="card-header pgHederSpceArnd">
                        <div className="d-flex justify-content-between align-items-center">
                        <h5 class="card-title">
                          {translate("Event Management")}
                        </h5>
                        <p>
                          Default Language:{" "}
                          {
                            Helper.languages.find(
                              (language) => language.langCode === langSelected
                            )?.name
                          }
                        </p>
                        </div>
                      </div>

                      <Col sm="12" md="8" lg="4" className="p-3 mx-auto">
                        <FormGroup>
                          <label>{translate("List of Events")}</label>
                          <CustomDropdown
                            data={data}
                            selectedEventId={selectedEventId}
                            handleSelectChangeTheme={handleSelectChangeTheme}
                          />
                          {/* <select className="form-control" value={selectedEventId} onChange={handleSelectChangeTheme}>
                            <option>Select Event</option>
                            {data.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.event_name}-{item.theme_name}
                              </option>
                            ))}
                          </select> */}
                        </FormGroup>
                       
                        <button
                          className="btn btn-primary"
                          onClick={(e) => HandleSubmitEvent(e)}
                        >
                          {translate("Select Event")}
                        </button>
                        <br/>
                        <br/>
                      </Col>
                      <div className="col-lg-12 text-right relative">
                        <div className="">
                          <VirtualKeyboard lang={langSelected} />
                        </div>
                      </div>
                      {showForm && (
                        <div class="card-body">
                          {/* <Form onSubmit={handleSubmit}> */}
                            <Row>
                              <Col md="12">
                                <FormGroup>
                                  {InputFields.slice(0, 1).map(
                                    (fieldConfig) => (
                                      <InputField12
                                        initialValues={initialValues}
                                        setInitialValues={setInitialValues}
                                        // saveField={saveField}
                                        key={fieldConfig.name}
                                        name={fieldConfig.name}
                                        value={initialValues[fieldConfig.name]}
                                        disabled={fieldConfig.disabled}
                                        label={fieldConfig.label}
                                        placeholder={fieldConfig.placeholder}
                                        innerRef={fieldConfig.innerRef}
                                        handleSpeak={fieldConfig.handleSpeak}
                                        handleFocusChange={handleFocusChange}
                                        nextRef={nextRef}
                                        nextValueRef={nextValueRef}
                                        resetRef={resetRef}
                                        timer={timer}
                                        setFieldValue={setFieldValue}
                                        getActive={getActive}
                                        handleActive={handleActive}
                                        langSelected={langSelected}
                                        getActiveState={getActiveState}
                                        onBtnRef={onBtnRef}
                                        skipFocusChange={skipFocusChange}
                                        skipBtn={translate("Skip")}
                                        transcript={transcript}
                                        listening={listening}
                                        voiceSelected={voiceSelected}
                                        resetTranscript={resetTranscript}
                                        required={fieldConfig.required}
                                        isKeyBoardInput={isKeyBoardInput}
                                        handleSpeakWithoutVoice={
                                          handleSpeakWithoutVoice
                                        }
                                        disableRef={disableRef}
                                        requiredBtn={translate("Required")}
                                      />
                                    )
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <Row>
                                  {InputFields.slice(1, 2).map(
                                    (fieldConfig) => (
                                      <div
                                        key={fieldConfig?.name}
                                        onFocus={(e) => {
                                          handleActive(e);
                                        }}
                                        className={`col-4 form-group ${getActive === fieldConfig.name
                                            ? "active"
                                            : null
                                          } `}
                                      >
                                        <label htmlFor={fieldConfig.name}>
                                          {fieldConfig.label}
                                        </label>
                                        <div
                                          className={`formgroupIn ${fieldConfig.disabled
                                              ? "checkDisabled"
                                              : ""
                                            }`}
                                          key={fieldConfig?.name}
                                        >
                                          <Field
                                            onFocus={(e) => {
                                              getActiveState.current =
                                                fieldConfig.name;
                                              handleActive(e);
                                              handleSpeakWithoutVoice(
                                                fieldConfig.name,
                                                langSelected,
                                                voiceSelected,
                                                getActiveState,
                                                fieldConfig.label
                                              );
                                            }}
                                            innerRef={fieldConfig.innerRef}
                                            as="select"
                                            className="form-control"
                                            id={fieldConfig.name}
                                            name={fieldConfig.name}
                                            disabled={
                                              (disableRef.current === true
                                                ? getActive === fieldConfig.name
                                                  ? false
                                                  : false
                                                : false) || fieldConfig.disabled
                                            }
                                            onChange={(e) => {
                                              handleSelectChange(e);
                                              subThemeRef.current.focus();
                                            }}
                                          >
                                            <option
                                              key={fieldConfig.value}
                                              value={fieldConfig.value}
                                            >
                                              {
                                                selectedThemeData[
                                                fieldConfig.name
                                                ]
                                              }
                                            </option>
                                            {fieldConfig.selectOptions.map(
                                              (option) => (
                                                <option
                                                  key={option.value}
                                                  value={option.value}
                                                >
                                                  {translate(option.label)}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                        </div>
                                      </div>
                                    )
                                  )}

                                  {InputFields.slice(2, 3).map(
                                    (fieldConfig) => (
                                      <div
                                        // ref={fieldConfig.innerRef}
                                        key={fieldConfig.name}
                                        onFocus={(e) => {
                                          handleActive(e);
                                          handleActive(e);
                                        }}
                                        className={`col-4 form-group active ${getActive === fieldConfig.name
                                            ? "active"
                                            : null
                                          } `}
                                      >
                                        <label htmlFor={fieldConfig.name}>
                                          {fieldConfig.label}
                                        </label>
                                        <div className="formgroupIn">
                                          <Field name={fieldConfig.name}>
                                            {({ field, form }) => {
                                              const handleChange = (
                                                selectedOptions
                                              ) => {
                                                form.setFieldValue(
                                                  field.name,
                                                  selectedOptions.map(
                                                    (option) => option.value
                                                  )
                                                );
                                                handleSubThemeChange(
                                                  selectedOptions
                                                );
                                              };
                                              return (
                                                <Select
                                                  {...field}
                                                  ref={fieldConfig.innerRef}
                                                  isMulti
                                                  name="sub_themes"
                                                  options={selectedThemeData.sub_themes.map(
                                                    (item) => ({
                                                      value: item,
                                                      label: item,
                                                    })
                                                  )}
                                                  className={`${getActive ===
                                                      fieldConfig.name
                                                      ? "active"
                                                      : null
                                                    } basic-multi-select form-group`}
                                                  classNamePrefix="select"
                                                  value={selectedThemeData.sub_themes.map(
                                                    (item) => ({
                                                      value: item,
                                                      label: item,
                                                    })
                                                  )}
                                                  onChange={handleChange}
                                                  // innerRef={fieldConfig.innerRef}
                                                  onFocus={(e) => {
                                                    getActiveState.current =
                                                      fieldConfig.name;
                                                    handleActive(e);
                                                    handleSpeakWithoutVoice(
                                                      fieldConfig.name,
                                                      langSelected,
                                                      voiceSelected,
                                                      getActiveState,
                                                      fieldConfig.label
                                                    );
                                                  }}
                                                  isDisabled={
                                                    (disableRef.current === true
                                                      ? getActive ===
                                                        fieldConfig.name
                                                        ? false
                                                        : false
                                                      : false) ||
                                                    fieldConfig.disabled
                                                  }
                                                />
                                              );
                                            }}
                                          </Field>
                                        </div>
                                      </div>
                                    )
                                  )}
                                  {InputFields.slice(3, 9).map((fieldConfig) =>
                                    renderInputFields(
                                      fieldConfig,
                                      setFieldValue
                                    )
                                  )}
                                </Row>
                              </Col>
                              <Col md="12">
                                <FormGroup>
                                  {" "}
                                  <h2 className="partcpntHdng">
                                  {translate("Number of Participants")}
                                  </h2>{" "}
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                <Row>
                                  {InputFields.slice(9, 14).map((fieldConfig) =>
                                    renderInputFields(
                                      fieldConfig,
                                      setFieldValue
                                    )
                                  )}
                                  {InputFields.slice(14, 15).map(
                                    (fieldConfig) => (
                                      <div
                                        key={fieldConfig.name}
                                        onFocus={(e) => {
                                          handleActive(e);
                                        }}
                                        className={`col-4 form-group ${getActive === fieldConfig.name
                                            ? "active"
                                            : null
                                          } `}
                                      >
                                        <label htmlFor={fieldConfig.name}>
                                          {fieldConfig.label}
                                        </label>
                                        <div className="formgroupIn">
                                          <Field
                                            onFocus={(e) => {
                                              getActiveState.current =
                                                fieldConfig.name;
                                              handleActive(e);
                                              handleSpeakWithoutVoice(
                                                fieldConfig.name,
                                                langSelected,
                                                voiceSelected,
                                                getActiveState,
                                                fieldConfig.label
                                              );
                                            }}
                                            innerRef={fieldConfig.innerRef}
                                            as="select"
                                            className="form-control"
                                            id={fieldConfig.name}
                                            name={fieldConfig.name}
                                            disabled={
                                              (disableRef.current === true
                                                ? getActive === fieldConfig.name
                                                  ? false
                                                  : false
                                                : false) || fieldConfig.disabled
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              handleSelectState(value);
                                              handleFocusChange(
                                                nextRef,
                                                nextValueRef,
                                                resetRef,
                                                timer
                                              );
                                            }}
                                          >
                                            {fieldConfig.selectOptions.map(
                                              (option) => (
                                                <option
                                                  key={option.value}
                                                  value={option.value}
                                                >
                                                  {translate(option.label)}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                        </div>
                                      </div>
                                    )
                                  )}
                                  {InputFields.slice(15, 16).map(
                                    (fieldConfig) => (
                                      <div
                                        key={fieldConfig.name}
                                        onFocus={(e) => {
                                          handleActive(e);
                                        }}
                                        className={`col-4 form-group ${getActive === fieldConfig.name
                                            ? "active"
                                            : null
                                          } `}
                                      >
                                        <label htmlFor={fieldConfig.name}>
                                          {fieldConfig.label}
                                        </label>
                                        <div className="formgroupIn">
                                          <Field
                                            onFocus={(e) => {
                                              getActiveState.current =
                                                fieldConfig.name;
                                              handleActive(e);
                                              handleSpeakWithoutVoice(
                                                fieldConfig.name,
                                                langSelected,
                                                voiceSelected,
                                                getActiveState,
                                                fieldConfig.label
                                              );
                                            }}
                                            innerRef={fieldConfig.innerRef}
                                            as="select"
                                            className="form-control"
                                            id={fieldConfig.name}
                                            name={fieldConfig.name}
                                            disabled={
                                              (disableRef.current === true
                                                ? getActive === fieldConfig.name
                                                  ? false
                                                  : false
                                                : false) || fieldConfig.disabled
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              setInitialValues({
                                                ...initialValues,
                                                district: value,
                                              });
                                              setDistrict(value);
                                              handleFocusChange(
                                                nextRef,
                                                nextValueRef,
                                                resetRef,
                                                timer
                                              );
                                            }}
                                          >
                                            <option
                                              key=""
                                              value=""
                                            >
                                              {translate("Select District")}
                                            </option>
                                            {filterDistrict.map((list, i) => (
                                              <option
                                                value={list.district_id}
                                              >
                                                {list.district_name}
                                              </option>
                                            ))}
                                          </Field>
                                        </div>
                                      </div>
                                    )
                                  )}
                                  {InputFields.slice(16, 18).map(
                                    (fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                  )}

                                  {captions
                                    .slice(0, 1)
                                    .map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}
                                  {InputFields.slice(18, 19).map((fieldConfig) =>
                                    renderInputFields(fieldConfig, setFieldValue)
                                  )
                                  }

                                  {captions
                                    .slice(1, 2)
                                    .map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}

                                  {(initialValues.theme_name ===
                                    "Adopt Healthy Lifestyles" ||
                                    initialValues.theme_name ===
                                    "स्वस्थ जीवनशैली अपनाएं" ||
                                    initialValues.theme_name ===
                                    "ಆರೋಗ್ಯಕರ ಜೀವನ ಶೈಲಿಗಳನ್ನು ಅಂಗೀಕರಿಸಿ" ||
                                    initialValues.theme_name ===
                                    "ఆరోగ్యకర జీవన శైలిని అవలంబించండి" ||
                                    initialValues.theme_name ===
                                    "ஆரோக்கியமான வாழ்க்கை முறைகளை ஏற்றுக்கொள்ளுங்கள்" ||
                                    initialValues.theme_name ===
                                    "ആരോഗ്യകരമായ ജീവിതശൈലികൾ സ്വീകരിക്കുക" ||
                                    initialValues.theme_name ===
                                    "সুস্থ জীবনধারা গ্রহণ করুন" ||
                                    initialValues.theme_name ===
                                    "ಆರೋಗ್ಯಕರ ಜೀವನ ಶೈಲಿಗಳನ್ನು ಅಂಗೀಕರಿಸಿ" ||
                                    initialValues.theme_name ===
                                    "ସ୍ୱାସ୍ଥ୍ୟକର ଜୀବନଶୈଳୀ ଅପନାନ୍ତୁ" ||
                                    initialValues.theme_name ===
                                    "आरोग्यदायी जीवनशैली अवलंबा" ||
                                    initialValues.theme_name ===
                                    "ਤੰਦਰੁਸਤ ਜੀਵਨ ਸ਼ੈਲੀਆਂ ਅਪਣਾਓ" ||
                                    initialValues.theme_name ===
                                    "صحت مند طرز زندگی اپنائیں" ||
                                    initialValues.theme_name ===
                                    "স্বাস্থ্যকৰ জীৱনশৈলী গ্ৰহণ কৰক") &&
                                    adoptHealthyLifestyles.map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}
                                    {
                                      (initialValues.theme_name === "Adopt sustainable food systems" ||
                                        initialValues.theme_name === "सतत खाद्य प्रणालियाँ अपनाएं" ||
                                        initialValues.theme_name === "సుస్థిర ఆహార వ్యవస్థలను అవలంబించండి" ||
                                        initialValues.theme_name === "தற்சமய உணவுக் கட்டமைப்புகளை ஏற்றுக்கொள்ளுங்கள்" ||
                                        initialValues.theme_name === "സുസ്ഥിര ഭക്ഷ്യ വ്യവസ്ഥകൾ സ്വീകരിക്കുക" ||
                                        initialValues.theme_name === "स्थितिशील खाद्य система গ্রহণ करें" ||
                                        initialValues.theme_name === "ಸಂಸ್ಥೆವಂತ ಆಹಾರ ವ್ಯವಸ್ಥೆಗಳನ್ನು ಅಂಗೀಕರಿಸಿ" ||
                                        initialValues.theme_name === "ସୁସ୍ଥିର ଖାଦ୍ୟ ପ୍ରଣାଳୀ ଅପନାନ୍ତୁ" ||
                                        initialValues.theme_name === "शाश्वत अन्न प्रणाली अवलंबा" ||
                                        initialValues.theme_name === "ਸਥਾਈ ਖੁਰਾਕ ਪ੍ਰਣਾਲੀਆਂ ਅਪਣਾਓ" ||
                                        initialValues.theme_name === "پائیدار خوراک کے نظام اپنائیں" ||
                                        initialValues.theme_name === "সতত খাদ্য প্ৰণালী গ্ৰহণ কৰক") &&
                                        adoptSustainableFoodSystems.map((fieldConfig, index) => {
                                          const selectedValue = kitchenGardensRef.current?.value || 0;
                                          console.log(`Value for this field in kitchenGardensRef: ${selectedValue}`);
                                          
                                          if (index === 1 && selectedValue == "Yes") {
                                            return renderInputFields(fieldConfig, setFieldValue);
                                          }
                                          
                                          if (index === 1 && (initialValues[fieldConfig.name] === " " || !initialValues[fieldConfig.name])) {
                                            return null;
                                          }
                                          
                                          console.log(`Rendering field at index ${index}`);
                                          return renderInputFields(fieldConfig, setFieldValue);
                                        })
                                    }

                                  {(initialValues.theme_name ===
                                    "Reduce E-Waste" ||
                                    initialValues.theme_name ===
                                    "ई-कचरा कम करें" ||
                                    initialValues.theme_name ===
                                    "ఇ-వ్యర్థాలను తగ్గించండి" ||
                                    initialValues.theme_name ===
                                    "மின்கழிவுகளை குறைக்கவும்" ||
                                    initialValues.theme_name ===
                                    "ഇ-മാലിന്യങ്ങൾ കുറയ്ക്കുക" ||
                                    initialValues.theme_name ===
                                    "ই-বর্জ্য হ্রাস করুন" ||
                                    initialValues.theme_name ===
                                    "ಇ-ತೆಚ್ಚು ಕಡಿಮೆ ಮಾಡಿರಿ" ||
                                    initialValues.theme_name ===
                                    "ଇ-ଆବର୍ଜନା କମାନ୍ତୁ" ||
                                    initialValues.theme_name ===
                                    "ई-कचरा कमी करा" ||
                                    initialValues.theme_name ===
                                    "ਈ-ਕਚਰਾ ਘਟਾਓ" ||
                                    initialValues.theme_name ===
                                    "ای فضلہ کم کریں" ||
                                    initialValues.theme_name ===
                                    "ই-বর্জ্য হ্রাস কৰক") &&
                                    reduceEwaste.map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}

                                  {(initialValues.theme_name ===
                                    "Reduce Waste" ||
                                    initialValues.theme_name ===
                                    "अपशिष्ट कम करें" ||
                                    initialValues.theme_name ===
                                    "వ్యర్థాలను తగ్గించండి" ||
                                    initialValues.theme_name ===
                                    "கழிவுகளை குறைக்கவும்" ||
                                    initialValues.theme_name ===
                                    "മാലിന്യങ്ങൾ കുറയ്ക്കുക" ||
                                    initialValues.theme_name ===
                                    "বর্জ্য হ্রাস করুন" ||
                                    initialValues.theme_name ===
                                    "ತೆಚ್ಚು ಕಡಿಮೆ ಮಾಡಿರಿ" ||
                                    initialValues.theme_name ===
                                    "ଆବର୍ଜନା କମାନ୍ତୁ" ||
                                    initialValues.theme_name ===
                                    "कचरा कमी करा" ||
                                    initialValues.theme_name ===
                                    "ਬর্জ਼ਾ ਘਟਾਓ" ||
                                    initialValues.theme_name ===
                                    "فضلہ کم کریں" ||
                                    initialValues.theme_name ===
                                    "আৱর্জনা হ্ৰাস কৰক") &&
                                    reduceWaste.map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}

                                  {(initialValues.theme_name ===
                                    "Save Energy" ||
                                    initialValues.theme_name ===
                                    "ऊर्जा बचाएं" ||
                                    initialValues.theme_name ===
                                    "శక్తిని ఆదా చేయండి" ||
                                    initialValues.theme_name ===
                                    "மின்சாரத்தை சேமிக்கவும்" ||
                                    initialValues.theme_name ===
                                    "ഊർജ്ജം സംരക്ഷിക്കുക" ||
                                    initialValues.theme_name ===
                                    "শক্তি সংরক্ষণ করুন" ||
                                    initialValues.theme_name ===
                                    "ಶಕ್ತಿಯನ್ನು ಉಳಿಸಿ" ||
                                    initialValues.theme_name ===
                                    "ଶକ୍ତି ସଞ୍ଚୟ କରନ୍ତୁ" ||
                                    initialValues.theme_name ===
                                    "ऊर्जा वाचवा" ||
                                    initialValues.theme_name === "ਉਰਜਾ ਬਚਾਓ" ||
                                    initialValues.theme_name ===
                                    "توانائی بچائیں" ||
                                    initialValues.theme_name ===
                                    "শক্তি সংৰক্ষণ কৰক") &&
                                    saveEnergy.map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}

                                  {(initialValues.theme_name === "Save Water" ||
                                    initialValues.theme_name === "पानी बचाएं" ||
                                    initialValues.theme_name ===
                                    "నీటిని ఆదా చేయండి" ||
                                    initialValues.theme_name ===
                                    "நீரை சேமிக்கவும்" ||
                                    initialValues.theme_name ===
                                    "വെള്ളം സംരക്ഷിക്കുക" ||
                                    initialValues.theme_name ===
                                    "জল সংরক্ষণ করুন" ||
                                    initialValues.theme_name ===
                                    "ನೀರನ್ನು ಉಳಿಸಿ" ||
                                    initialValues.theme_name ===
                                    "ପାଣି ସଞ୍ଚୟ କରନ୍ତୁ" ||
                                    initialValues.theme_name === "पाणी वाचवा" ||
                                    initialValues.theme_name === "ਪਾਣੀ ਬਚਾਓ" ||
                                    initialValues.theme_name ===
                                    "پانی بچائیں" ||
                                    initialValues.theme_name ===
                                    "পানী সংৰক্ষণ কৰক") &&
                                    saveWater.map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}

                                  {(initialValues.theme_name ===
                                    "Say No to Single Use Plastic" ||
                                    initialValues.theme_name ===
                                    "एकल उपयोग प्लास्टिक को ना कहें" ||
                                    initialValues.theme_name ===
                                    "ఒకసారి ఉపయోగించే ప్లాస్టిక్‌కు నో చెప్పండి" ||
                                    initialValues.theme_name ===
                                    "ஒரு முறை பயன்படுத்தும் பிளாஸ்டிக்குக்கு இல்லை சொல்" ||
                                    initialValues.theme_name ===
                                    "ഒറ്റത്തവണ ഉപയോഗിക്കുന്ന പ്ലാസ്റ്റിക്കിന് ഇല്ല എന്ന് പറയുക" ||
                                    initialValues.theme_name ===
                                    "একবার ব্যবহৃত প্লাস্টিককে না বলুন" ||
                                    initialValues.theme_name ===
                                    "ಏಕ ಬಾರಿಗೆ ಬಳಸುವ ಪ್ಲಾಸ್ಟಿಕ್ ಗೆ ಇಲ್ಲವೆಂದು ಹೇಳಿ" ||
                                    initialValues.theme_name ===
                                    "ଏକକ ବ୍ୟବହାରୀ ପ୍ଲାଷ୍ଟିକ୍ କୁ ନାକରନ୍ତୁ" ||
                                    initialValues.theme_name ===
                                    "एकवेळच्या वापराच्या प्लास्टिकला नाही म्हणा" ||
                                    initialValues.theme_name ===
                                    "ਇੱਕੋ ਵਰਤੋਂ ਵਾਲੇ ਪਲਾਸਟਿਕ ਨੂੰ ਨਾ ਕਹੋ" ||
                                    initialValues.theme_name ===
                                    "سنگل یوز پلاسٹک کو نہ کہیں" ||
                                    initialValues.theme_name ===
                                    "এবাৰহে ব্যৱহাৰ কৰিব পৰা প্লাষ্টিকক ‘না’ কওক") &&
                                    sayNoToSingleUsePlastic.map((fieldConfig) =>
                                      renderInputFields(
                                        fieldConfig,
                                        setFieldValue
                                      )
                                    )}
                                </Row>
                              </Col>
                              <Col md="12">
                                <FormGroup>
                                  <button
                                    className="btn btn-primary"
                                    type="submit" disabled={isSubmitting} 
                                    onClick={(e)=>handleSubmit(e)}
                                  >
                                    {" "}
                                    Update{" "}
                                  </button>
                                </FormGroup>
                              </Col>
                            </Row>
                          {/* </Form> */}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Form>
        )}
      </Formik>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        mediaUrl={mediaUrl}
        isVideo={isVideo}
        setModalShow={(value) => {
          setModalShow(value);
        }}
      />
    </>
  );
}

export default EventManagement;

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <span onClick={() => props.setModalShow(false)} className="closebtn">
        X
      </span>
      <Modal.Body style={{ padding: 20 }}>
        {props.isVideo ? (
          <video controls style={{ width: "100%", height: 500 }}>
            <source src={props.mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={props.mediaUrl} alt="" style={{ width: "100%" }} />
        )}
      </Modal.Body>
    </Modal>
  );
}
